<fury-page-layout>
    <fury-page-layout-content @fadeInUp>
        <fury-container>
            <h1>Notificaties</h1>
            <ng-container *ngIf="publicNotification">
                <h3>
                    <mat-chip-list>
                        <mat-chip [style.background]="publicNotification.type.color">
                            {{ publicNotification.type.display_name }}
                        </mat-chip>
                    </mat-chip-list>
                </h3>
                <h2>{{ publicNotification.title }}</h2>
                <div [innerHTML]="publicNotification.content"></div>
            </ng-container>
            <ng-container *ngIf="!publicNotification && !isLoading">
                <p>Geen notificatie.</p>
            </ng-container>
            <ng-container *ngIf="!publicNotification && isLoading">
                <mat-spinner diameter="24" mode="indeterminate"></mat-spinner>
            </ng-container>
        </fury-container>
    </fury-page-layout-content>
</fury-page-layout>
